<template>
  <v-datetime-picker
    v-model="dateTime"
    :label="label"
    :disabled="disabled"
    no-title
    @input="updateFormattedDateTime"
    v-bind="$attrs"
    v-on="$listeners"
    locale="pt-BR"
    dateFormat="dd/MM/yyyy"
    :timeFormat="hasSeconds ? 'HH:mm:ss' : 'HH:mm'"
    :clearText="$t('new-event.buttons.clear')"
    :okText="$t('new-event.buttons.confirm')"
    :color="$config.dados.corinputs"
    theme="light"
    background-color="primary"
    :timePickerProps="{
      showSeconds: false,
      format: '24hr',
      amPm: false,
      color: $config.dados.corinputs,
    }"
    :datePickerProps="{
      multiple: range,
      firstDayOfWeek: 1,
      format: 'dd/MM/yyyy',
      locale: locale,
      color: $config.dados.corinputs,
      allowedDates: allowedDatesFunction,
    }"
    :textFieldProps="
      simpleStyle
        ? {
            placeholder: placeholder || $t('new-event.datepicket-placeholder'),
            hideDetails: hideDetails || 'auto',
            solo: false,
            persistentPlaceholder: true,
            dense: true,
            class: 'mt-2',
          }
        : {
            class: 'rounded-lg',
            hideDetails: hideDetails || 'auto',
            solo: false,
            outlined: true,
            dense: true,
            appendIcon: 'mdi-calendar-clock-outline',
            color: 'tertiary',
            persistentPlaceholder: true,
            placeholder: placeholder || $t('new-event.datepicket-placeholder'),
            rules: rules,
          }
    "
  >
    <template v-slot:dateIcon>
      <v-icon color="tertiary">mdi-calendar-range</v-icon>
    </template>
    <template v-slot:timeIcon>
      <v-icon color="tertiary">mdi-clock-time-eight-outline</v-icon>
    </template>
  </v-datetime-picker>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "DateTimePicker",
  props: {
    label: String,
    disabled: Boolean,
    edit: String,
    rules: Array,
    range: {
      type: Boolean,
      default: false,
    },
    simpleStyle: Boolean,
    allowedDates: {
      type: [Function, Array],
    },
    hideDetails: Boolean,
    hasSeconds: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
  },
  data() {
    return {
      menu: false,
      dateTime: this.range ? [] : null,
    };
  },
  watch: {
    edit() {
      this.handleEditDateTime();
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale.replace("_", "-");
    },
  },
  methods: {
    updateFormattedDateTime() {
      let formattedDateTime = null;
      const formatWithSeconds = "YYYY-MM-DD HH:mm:ss";
      const formatWithoutSeconds = "YYYY-MM-DD HH:mm";

      const dateFormat = this.hasSeconds
        ? formatWithSeconds
        : formatWithoutSeconds;
      if (this.range || Array.isArray(this.dateTime)) {
        formattedDateTime = this.dateTime
          .filter(date => dayjs(date).isValid())
          .map(date => dayjs(date).format(dateFormat))
          .join(" - ");
      } else if (this.dateTime && dayjs(this.dateTime).isValid()) {
        formattedDateTime = dayjs(this.dateTime).format(dateFormat);
      }
      this.$emit("formatted-date", formattedDateTime);
    },
    allowedDatesFunction(date) {
      if (Array.isArray(this.allowedDates)) {
        return this.allowedDates.includes(dayjs(date).format("YYYY-MM-DD"));
      }
      if (typeof this.allowedDates === "function") {
        return this.allowedDates(date);
      }
      return true;
    },
    handleEditDateTime() {
      if (typeof this.edit === "string") {
        this.dateTime = dayjs(this.edit).isValid()
          ? dayjs(this.edit).toDate()
          : null;
      } else if (this.edit instanceof Date && !isNaN(this.edit)) {
        this.dateTime = this.edit;
      } else {
        this.dateTime = null;
      }
      this.updateFormattedDateTime();
    },
  },
  mounted() {
    if (this.edit) {
      this.handleEditDateTime();
    }
  },
};
</script>

<style scoped></style>
